/**
 * API Configuration
 * Handles API and WebSocket URLs for different environments
 */

// Get API base URL
export const API_URL = import.meta.env.VITE_API_URL || '';

// Get WebSocket URL
export const WS_URL = import.meta.env.VITE_WS_URL ||
  (typeof window !== 'undefined'
    ? `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}`
    : 'ws://localhost:3000');

/**
 * Get full API URL for a given path
 * In development, returns relative path (uses Vite proxy)
 * In production, returns absolute URL with API_URL
 */
export function getApiUrl(path: string): string {
  if (import.meta.env.DEV) {
    // In development, use relative URLs (Vite proxy handles it)
    return path;
  }

  // In production, use absolute API URL
  return `${API_URL}${path}`;
}

/**
 * Get WebSocket URL for queue updates
 * In development, connects to localhost:3000
 * In production, uses WS_URL environment variable
 */
export function getWebSocketUrl(shopId: string, type: 'cashier' | 'customer' = 'cashier'): string {
  if (import.meta.env.DEV) {
    // In development, use relative WebSocket URL
    return `ws://localhost:3000/ws?shopId=${shopId}&type=${type}`;
  }

  // In production, use absolute WebSocket URL
  const wsHost = WS_URL.replace('wss://', '').replace('ws://', '');
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${wsHost}/ws?shopId=${shopId}&type=${type}`;
}

/**
 * Fetch options with credentials included
 * Required for cross-origin cookie sharing
 */
export const fetchWithCredentials = {
  credentials: 'include' as RequestCredentials,
};
